var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeformShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2668_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.92 17.589H4.70602L2.61768 1.74261L17.92 4.40452V17.5964V17.589ZM6.00021 16.1184H16.4566V5.63988L4.33836 3.53683L6.00021 16.1257V16.1184Z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47803 3.5957C4.09532 3.5957 4.59573 3.09529 4.59573 2.478C4.59573 1.8607 4.09532 1.36029 3.47803 1.36029C2.86074 1.36029 2.36032 1.8607 2.36032 2.478C2.36032 3.09529 2.86074 3.5957 3.47803 3.5957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47802 3.96339C2.6618 3.96339 2 3.30159 2 2.48537C2 1.66915 2.6618 1 3.47802 1C4.29424 1 4.95604 1.6618 4.95604 2.47802C4.95604 3.29424 4.29424 3.95604 3.47802 3.95604V3.96339ZM3.47802 1.72798C3.06623 1.72798 2.72798 2.06623 2.72798 2.47802C2.72798 2.88981 3.06623 3.22806 3.47802 3.22806C3.88981 3.22806 4.22806 2.88981 4.22806 2.47802C4.22806 2.06623 3.88981 1.72798 3.47802 1.72798Z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46341 17.9714C6.0807 17.9714 6.58112 17.471 6.58112 16.8537C6.58112 16.2364 6.0807 15.736 5.46341 15.736C4.84612 15.736 4.3457 16.2364 4.3457 16.8537C4.3457 17.471 4.84612 17.9714 5.46341 17.9714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46342 18.3391C4.6472 18.3391 3.9854 17.6773 3.9854 16.8611C3.9854 16.0449 4.6472 15.3831 5.46342 15.3831C6.27964 15.3831 6.94144 16.0449 6.94144 16.8611C6.94144 17.6773 6.27964 18.3391 5.46342 18.3391ZM5.46342 16.111C5.05163 16.111 4.71338 16.4493 4.71338 16.8611C4.71338 17.2729 5.05163 17.6111 5.46342 17.6111C5.8752 17.6111 6.21346 17.2729 6.21346 16.8611C6.21346 16.4493 5.8752 16.111 5.46342 16.111Z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1846 5.88252C17.7816 5.88252 18.2656 5.39857 18.2656 4.80158C18.2656 4.2046 17.7816 3.72064 17.1846 3.72064C16.5877 3.72064 16.1037 4.2046 16.1037 4.80158C16.1037 5.39857 16.5877 5.88252 17.1846 5.88252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1846 6.22814C17.1037 6.22814 17.0155 6.22814 16.9346 6.20608C16.1552 6.06636 15.6404 5.32368 15.7801 4.54422C15.9199 3.76477 16.6625 3.25004 17.442 3.38975C17.817 3.45593 18.1479 3.66918 18.3612 3.97802C18.5744 4.28686 18.6627 4.66923 18.5965 5.04425C18.4715 5.73546 17.8685 6.22078 17.192 6.22078L17.1846 6.22814ZM17.1846 4.07361C16.839 4.07361 16.5375 4.32362 16.4714 4.66923C16.3978 5.05896 16.6625 5.44133 17.0596 5.50751C17.4494 5.58104 17.8317 5.31632 17.8979 4.91924C17.9714 4.52952 17.7067 4.14714 17.3096 4.08096C17.2655 4.07361 17.2214 4.06626 17.1846 4.06626V4.07361Z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1846 17.9714C17.8019 17.9714 18.3023 17.471 18.3023 16.8537C18.3023 16.2364 17.8019 15.736 17.1846 15.736C16.5673 15.736 16.0669 16.2364 16.0669 16.8537C16.0669 17.471 16.5673 17.9714 17.1846 17.9714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1846 18.3391C16.3684 18.3391 15.7066 17.6773 15.7066 16.8611C15.7066 16.0449 16.3684 15.3831 17.1846 15.3831C18.0008 15.3831 18.6626 16.0449 18.6626 16.8611C18.6626 17.6773 18.0008 18.3391 17.1846 18.3391ZM17.1846 16.111C16.7728 16.111 16.4346 16.4493 16.4346 16.8611C16.4346 17.2729 16.7728 17.6111 17.1846 17.6111C17.5964 17.6111 17.9347 17.2729 17.9347 16.8611C17.9347 16.4493 17.5964 16.111 17.1846 16.111Z",
    fill: "#98BDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2668_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.67,
    height: 17.3392,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeformShape);
export default __webpack_public_path__ + "static/media/freeform_shape.337fcc5635b206fad66bfe3e0982e3a6.svg";
export { ForwardRef as ReactComponent };